export const reviewSecret=()=>Array.from(crypto.getRandomValues(new Uint8Array(32)),b=>b.toString(16).padStart(2,'0')).join('');
export function parseReviewLink(hash) {
 const params=new URLSearchParams(hash.replace(/^#/,''));
 const id=params.get('review'),token=params.get('token');
 if(!/^[a-f0-9-]{36}$/i.test(id || '') || !/^[a-f0-9]{64}$/.test(token || ''))return null;
 return {id,token};
}
export function reviewRange(words,ids) {
 const indexes=ids.map(id=>words.findIndex(w=>w.id===id)).filter(i=>i>=0);
 if(!indexes.length)throw new Error('Select a passage first.');
 const first=Math.min(...indexes),last=Math.max(...indexes);
 if(last-first>=500)throw new Error('Choose a passage of up to 500 words.');
 return {first,last};
}
export function reviewLink(id,token,location=window.location) {return `${location.origin}${location.pathname}#review=${id}&token=${token}`;}
export async function reviewRpc(client,name,args) {const {data,error}=await client.rpc(name,args);if(error)throw new Error(error.message || 'Could not save review feedback.');return data;}
